import React from 'react';
import PropTypes from 'prop-types';
import { FlowStepToTopBarIndex, getStepType, TopBarIndex, TopBarIndexToFlowStep } from '../TopBar/TopBarHelper';
import styles from './OnBoardingStepper.scss';
import { FLOW_STEP } from '../../stateManagement/engine/reducers/SessionReducer';
import { translate} from 'react-i18next';
import { Stepper } from 'wix-style-react';

class OnBoardingStepper extends React.Component {
  onFlowStepClick = flowStepIndex => {
    const { onFlowStepClick, flowStep: currentFlowStep } = this.props;
    const flowStep = TopBarIndexToFlowStep[flowStepIndex];

    if (flowStep !== currentFlowStep) {
      onFlowStepClick({ state: { step: flowStep } });
    }
  };

  render() {
    const { flowStep, t } = this.props;

    return (
      <div className={styles.wrapper} data-hook="on-boarding-stepper">
        <Stepper
          activeStep={FlowStepToTopBarIndex[flowStep]}
          steps={[
            { text: t('phoneordering_customerinfo_steps_phone'), type: getStepType(TopBarIndex.PHONE, flowStep) },
            {
              text: t('phoneordering_customerinfo_steps_contact'),
              type: getStepType(TopBarIndex.CUSTOMER_DETAILS, flowStep),
            },
            { text: t('phoneordering_customerinfo_steps_ordertype'), type: getStepType(TopBarIndex.ADDRESS, flowStep) },
          ]}
          onClick={this.onFlowStepClick}
        />
      </div>
    );
  }
}

OnBoardingStepper.displayName = 'OnBoardingStepper';
OnBoardingStepper.propTypes = {
  flowStep: PropTypes.string,
  onFlowStepClick: PropTypes.func,
  t: PropTypes.func,
};
OnBoardingStepper.defaultProps = {
  flowStep: FLOW_STEP.IDLE,
};

export default translate()(OnBoardingStepper);
